import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'put'

export default class OspreyImagesUpdate extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d426b0'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(image) {
        if (!image) {
            throw new Error('Missing image object')
        }

        this.path = `/${resource}/${image.id.value}`

        this.params = {
            image
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-update.js